import * as React from 'react';
import { Component } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { createSidebar } from '../../redux/actions/general/sidebar';
import {
  __,
  dateFrom,
  dateTimeFrom,
  getActiveStage,
  getURLParam,
  mapStateToProps,
  redirect,
  setTableParams,
} from '../../core/utils';
import Table from '../../components/Table';
import { setPlusActions } from '../../redux/actions/general/plus';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import * as _ from 'lodash';
import Tooltip from '../../components/Tooltip';
import { getTeamsPermissions } from '../../redux/actions/table/teams';
import { setNotification } from '../../redux/actions/general/notification';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import InfoPositiveIcon from '../../assets/images/info-positive-16x16.svg';
import {
  deleteRoomGroups,
  listRoomGroups,
  readRoomGroup,
} from '../../redux/actions/table/room_groups';
import RoomGroupsFlyout from '../../flyouts/room_groups/RoomGroupsFlyout';
import classNames from 'classnames';
import styles from '../../styles/views/space_allocation/Entrances.scss';
import ArrowDoubleRightSmallIcon from '../../assets/images/arrow-double-right-small-15x15.svg';
import TableNA from '../../components/TableNA';
import Avatar from '../../components/Avatar';

@mapStateToProps((state) => ({
  table: state.table['room_groups'],
}))
class RoomGroups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preview: null,
    };
  }

  componentDidMount() {
    getTeamsPermissions(this.props.match.params.stage).then(({ response }) => {
      this.setState({ team_roles: _.get(response.data, 'teams', {}) });

      !_.isEmpty(this.state.team_roles.editor) &&
        setPlusActions([
          {
            title: __('space-allocation.room-groups.table.button.create'),
            onClick: () =>
              setTableParams('room_groups', {
                add_room_group_wizard: true,
              }),
          },
        ]);
    });

    enableProjectsDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/space_allocation/room_groups')
    );
    enableStagesDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/space_allocation/room_groups')
    );

    createSidebar({
      title: __('submenu.title.space-allocation'),
      items: [
        {
          title: __('submenu.title.space-allocation.rooms'),
          link: () => '/stages/' + getActiveStage() + '/space_allocation/rooms',
        },
        {
          title: __('submenu.title.space-allocation.room-types'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/room_types',
        },
        {
          title: __('submenu.title.space-allocation.room-groups'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/room_groups',
          active: true,
        },
        {
          title: __('submenu.title.space-allocation.zones'),
          link: () => '/stages/' + getActiveStage() + '/space_allocation/zones',
        },
        {
          title: __('submenu.title.space-allocation.entrances'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/entrances',
        },
        {
          title: __('submenu.title.space-allocation.expansion-joints'),
          link: () =>
            '/stages/' +
            getActiveStage() +
            '/space_allocation/expansion_joints',
        },
        {
          title: __('submenu.title.space-allocation.storeys'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/storeys',
        },
        {
          title: __('submenu.title.space-allocation.buildings'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/buildings',
        },
        {
          title: __('submenu.title.space-allocation.sites'),
          link: () => '/stages/' + getActiveStage() + '/space_allocation/sites',
        },
      ],
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.table.clicked_row &&
      this.props.table.clicked_row !== prevProps.table.clicked_row
    ) {
      if (!prevProps.table.clicked_row) {
        this.setState({ preview: undefined });
      }

      readRoomGroup(this.props.table.clicked_row).then(({ response }) => {
        this.setState({ preview: response.data });
      });
    }
  }

  render() {
    const columns = [
      {
        key: 'code',
        name: __('room-groups.field.code'),
        default: true,
        value: (code) => code || <TableNA />,
        width: 100,
      },
      {
        key: 'title',
        name: __('room-groups.field.title'),
        required: true,
        sortable: false,
      },
      {
        key: 'rooms',
        name: __('room-groups.field.rooms'),
        value: (rooms, row) => (
          <div
            className={classNames(styles.rooms)}
            onClick={() => {
              setTableParams(
                'rooms',
                _.transform(
                  [
                    'filter.site',
                    'filter.building',
                    'filter.storey',
                    'filter.expansion_joint',
                    'filter.entrance',
                    'filter.zone',
                    'filter.functional_space',
                    'filter.foh',
                    'filter.outdoor',
                    'filter.room_group',
                    'filter.room_type',
                    'filter.security',
                    'filter.date',
                    'filter.creator',
                    'query',
                  ],
                  (filters, filter) => {
                    filters[filter] = '';

                    return filters;
                  },
                  {}
                )
              );

              redirect(
                '/stages/' +
                  this.props.match.params.stage +
                  '/space_allocation/rooms?filter.room_group=' +
                  row.id
              );
            }}
          >
            {rooms}
            <ArrowDoubleRightSmallIcon />
          </div>
        ),
        width: 60,
        sortable: false,
      },
      {
        key: 'created_at',
        name: __('room-groups.field.created-at'),
        value: (created_at) => (
          <Tooltip text={dateTimeFrom(created_at)}>
            {dateFrom(created_at)}
          </Tooltip>
        ),
        width: 80,
      },
      {
        key: 'created_by',
        name: __('room-groups.field.created-by'),
        value: (user) => (
          <Avatar
            avatar_url={user.avatar_url}
            name={user.fullname}
            active={user.active}
          />
        ),
        width: 50,
      },
    ];

    const singleActions = (room_group_id) => {
      return [
        <Tooltip
          text={__('room-groups.tooltip.room-group-properties')}
          key={_.uniqueId()}
        >
          <InfoPositiveIcon
            className=''
            onClick={(e) => {
              e.stopPropagation();

              setTableParams('room_groups', {
                clicked_row: room_group_id,
                actioned_row: undefined,
              });
            }}
          />
        </Tooltip>,
        <Tooltip
          text={__('room-groups.tooltip.delete-room-group')}
          key={_.uniqueId()}
        >
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();

              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description: __('room-groups.alert.delete-confirmation'),
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-delete'),
                    onClick: () => {
                      deleteRoomGroups([room_group_id]).then(() => {
                        hideAlertbox();

                        setNotification(__('room-groups.alert.deleted'));
                        listRoomGroups(this.props.match.params.stage);

                        setTableParams('room_groups', {
                          actioned_row: undefined,
                        });
                      });
                    },
                  },
                ],
              });
            }}
          />
        </Tooltip>,
      ];
    };

    const groupActions = (room_groups_ids) => [
      <Tooltip
        text={__('room-groups.tooltip.delete-selected-room-groups')}
        key={_.uniqueId()}
      >
        <DeleteIcon
          onClick={(e) => {
            e.stopPropagation();

            showAlertbox({
              color: 'red',
              title: __('general.alert.are-you-sure'),
              description: __('room-groups.alert.multiple-delete-confirmation'),
              buttons: [
                {
                  color: 'lightGray',
                  text: __('general.alert.no-close'),
                  onClick: 'close',
                },
                {
                  color: 'gray',
                  text: __('general.alert.yes-delete'),
                  onClick: () => {
                    deleteRoomGroups(room_groups_ids).then(() => {
                      hideAlertbox();

                      setNotification(__('room-groups.alert.multiple-deleted'));
                      listRoomGroups(this.props.match.params.stage);

                      setTableParams('room_groups', {
                        selected_rows: [],
                      });
                    });
                  },
                },
              ],
            });
          }}
        />
      </Tooltip>,
    ];

    const preview = (
      <RoomGroupsFlyout
        data={this.state.preview}
        readAction={(room_group_id) => {
          return new Promise((resolve) => {
            readRoomGroup(getURLParam('id') || room_group_id).then(
              ({ response }) => {
                this.setState({ preview: response.data });

                resolve(response);
              }
            );
          });
        }}
      />
    );

    return (
      <Table
        listAction={() => listRoomGroups(this.props.match.params.stage)}
        name='room_groups'
        title={__('submenu.title.space-allocation.room-groups')}
        singleActions={singleActions}
        groupActions={groupActions}
        columns={columns}
        preview={this.state.preview ? preview : []}
        onLoad={() => listActiveModules()}
      />
    );
  }
}

export default RoomGroups;
